import { useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import { useDispatch } from "react-redux";
import { v4 as uuidv4 } from "uuid";
import Spinner from "react-bootstrap/Spinner";
import { ModalSizeTypes } from "@enums/modal-size-types";
import { addLoadingIndicator, removeLoadingIndicator } from "@redux/actions/loading-indicators-actions";
import { DefaultModal } from "../default-modal/default-modal";
import defaultStyles from "../default-modal/default-modal.less";
import styles from "./spinner-modal.less";

type LoadingModalProps = {
    onModalClose: () => void;
    message: string;
}

export const SpinnerModal = (props: LoadingModalProps) => {
    const { onModalClose, message } = props;

    const dispatch = useDispatch();

    useEffect(() => {
        const uuid = uuidv4();
        dispatch(addLoadingIndicator(uuid));

        return () => {
            setTimeout(() => {
                // delay the execution of this function by 300 ms
                dispatch(removeLoadingIndicator(uuid));
            }, 300);
        }
    }, []);

    return (
        <DefaultModal
            automationId="loading-modal"
            ariaLabelledBy="loading-title"
            onHide={onModalClose}
            backdrop={"static"}
            keyboard={false}
            isMaxWidth={false}
            size={ModalSizeTypes.SMALL}
        >
            <Modal.Body className={styles.modalBody}>
                <span className={defaultStyles.description}>
                    {message}
                </span>

                <div>
                    <Spinner animation={"border"} />
                </div>
            </Modal.Body>
        </DefaultModal>
    );
};